/**
 * Product quiz -> Klaviyo, through the shared quiz tracker (quiz-tracker.js).
 * Keeps the metric and profile property names this store already used
 * (Started Product Quiz, Answered Quiz Question, Completed Product Quiz, quiz_status, ...).
 * The tracker also mirrors every step to the shared quiz-list server, which
 * keeps the profile up to date and puts every lead in the store's Klaviyo list.
 */
(function () {
  'use strict';

  function answerValue(a) {
    if (!a) return '';
    return a.values && a.values.length ? a.values : a.value;
  }

  function answerText(a) {
    var v = answerValue(a);
    return Array.isArray(v) ? v.join(', ') : (v || '');
  }

  function withEmail(answers, email) {
    if (email) answers.email = email;
    return answers;
  }

  window.HPNQuizTracker.init({
    rootSelector: '[data-product-quiz]',
    quizId: 'product_quiz',
    quizName: 'Product Quiz',
    eventPrefix: 'product-quiz:',
    propPrefix: 'quiz_',
    publicKey: 'TNdtER',
    tenant: 'onesol',
    listEndpoint: 'https://hpn-quiz-list.vercel.app/api/add-to-list',
    metrics: {
      'step-answered': 'Answered Quiz Question',
      'added-to-cart': 'Added Quiz Product to Cart'
    },
    trackOnly: { 'bundle-link-clicked': 'Clicked Quiz Product Link' },

    normalize: function (name, d) {
      var answers = {};
      if (name === 'started' || name === 'email-captured') {
        return Object.assign({}, d, { answers: withEmail(answers, d.email) });
      }
      if (name === 'step-answered') {
        var key = 'q' + (d.stepIndex + 1);
        answers[key] = answerValue(d);
        answers[key + '_question'] = d.question;
        return Object.assign({}, d, {
          step: key,
          viewedStep: d.stepIndex + 1 >= d.totalSteps ? 'result' : 'q' + (d.stepIndex + 2),
          answerText: answerText(d),
          answers: withEmail(answers, d.email)
        });
      }
      if (name === 'complete') {
        (d.answers || []).forEach(function (a, i) {
          if (!a) return;
          answers['q' + (i + 1)] = answerValue(a);
          answers['q' + (i + 1) + '_question'] = a.question;
        });
        return Object.assign({}, d, { answers: withEmail(answers, d.email) });
      }
      return d;
    },

    extra: function (name, d) {
      if (name === 'step-answered') {
        return {
          current_step: d.stepIndex + 1,
          total_steps: d.totalSteps,
          last_question: d.question,
          last_answer: d.answerText,
          answer: d.answerText
        };
      }
      if (name === 'complete') {
        return { result: d.tag, result_title: d.resultTitle, result_tag: d.tag };
      }
      if (name === 'bundle-link-clicked') return { result_tag: d.tag };
      if (name === 'added-to-cart') {
        return {
          items: (d.items || []).map(function (item) {
            return { ProductName: item.title, ProductVariant: item.variantTitle, Quantity: item.quantity, Price: item.price };
          })
        };
      }
      return {};
    }
  });
})();
